// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hr{border:1px solid #dbdbdb}", "",{"version":3,"sources":["webpack://./src/styles/global.scss"],"names":[],"mappings":"AAGA,GACE,wBAAA","sourcesContent":["@import '../../node_modules/@veneer/tokens/dist/tokens';\n@import './variables.scss';\n\nhr {\n  border: 1px solid $hr-color;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
